/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import ClassroomRouteLinkItem from './ClassroomRouteLinkItem';
import AttendanceIcon from 'icons/AttendanceIcon';
import {useUserContext} from 'app/UserContext';
import {useMidasJsonApi} from 'app/hooks';

const messages = defineMessages({
  title: {id: 'navigation.attendance'},
});

const MeetingAttendanceItem = () => {
  const [{classroom}] = useUserContext();

  const [response] = useMidasJsonApi({
    url: `/midas/rest/pd-section/${classroom.sectionID}?fields=id`,
    expectedStatus: [200, 404],
  });

  // If a PD section does not exist, do not show the PD attendance link (this item)
  if (!response.json?.section) {
    return null;
  }

  return (
    <ClassroomRouteLinkItem
      iconBefore={AttendanceIcon}
      route="midas/classroom/meeting-attendance"
      title={messages.title}
    />
  );
};

export default MeetingAttendanceItem;
